/*
 * Copyright (c) 2023 by N-Ach (Pvt) Ltd
 *
 * ╔═╗ ╔╗    ╔═══╗  ╔╗
 * ║║╚╗║║    ║╔═╗║  ║║
 * ║╔╗╚╝║    ║║ ║╠══╣╚═╗
 * ║║╚╗║║╔══╗║╚═╝║╔═╣╔╗║
 * ║║ ║║║╚══╝║╔═╗║╚═╣║║║
 * ╚╝ ╚═╝    ╚╝ ╚╩══╩╝╚╝
 *
 * All rights reserved.
 *
 * This software is the confidential and proprietary information
 * of N-Ach (Pvt) Ltd. You shall not disclose such Confidential
 * Information and shall use it only in accordance with the terms
 * of the license agreement you entered into with N-Ach (Pvt) Ltd.
 *
 *
 * @Author Dilhari Jayathunga
 * @Date 3/4/2023
 */

import {
  Box,
  ButtonGroup,
  IconButton,
  Pagination,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import { Delete, Edit } from "@mui/icons-material";
import { useDispatch } from "react-redux";
import { PaginationDetails } from "../../Utils/Utils";
import {
  openEditOfferModal,
  openDeleteOfferModal,
} from "../../Store/Slices/offerSlice";

const OfferTable = ( data ) => {
  const dispatch = useDispatch();

  const dataSet = Array.isArray(data.data) ? data.data : [];
  const { page, count, handleChange, _DATA } = PaginationDetails(dataSet);
  const roles = sessionStorage.getItem("roles")

  return (
    <>
      <TableContainer sx={{ height: "400px" }}>
        <Table
          stickyHeader
          aria-label="simple table"
          sx={{ height: "max-content" , borderSpacing:'0px 4px' }}
        >
          <TableHead>
            <TableRow>
              <TableCell width={50}>Offer Id</TableCell>
              <TableCell width={50}>Description</TableCell>
              <TableCell width={50}>Offer</TableCell>
              <TableCell align="center" width={"30%"}>
                Action
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {_DATA.currentData().map((offer) => (
              <TableRow sx={{ height: "30px" }} key={offer.offerId}>
                <TableCell
                  component="th"
                  scope="row"
                  sx={{
                    borderBottom: "none",
                    fontWeight: "bold",
                    width: 50,
                    height: "auto !important",
                  }}
                >
                  #{offer.offerId}
                </TableCell>
                <TableCell
                  sx={{
                    borderBottom: "none",
                    width: 100,
                    height: "auto !important",
                  }}
                >
                  {offer.offerDesc}
                </TableCell>
                <TableCell
                  sx={{
                    borderBottom: "none",
                    width: 50,
                    height: "auto !important",
                  }}
                >
                  {offer.off}
                </TableCell>
                <TableCell
                  align="center"
                  sx={{
                    borderBottom: "none",
                    width: "15%",
                    height: "auto !important",
                  }}
                >
                  <ButtonGroup variant="text" aria-label="text button group">
                    {roles?.split(",").includes("PRIV_ES_EDIT_OFFER") ?  (<IconButton
                      onClick={() => {
                        dispatch(openEditOfferModal(offer.offerId));
                      }}
                    >
                      <Edit />
                    </IconButton>) : null}
                    {roles?.split(",").includes("PRIV_ES_DELETE_OFFER") ?  (<IconButton
                      onClick={() => {
                        dispatch(openDeleteOfferModal(offer.offerId));
                      }}
                    >
                      <Delete />
                    </IconButton>) : null}
                  </ButtonGroup>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <Box my={2} display="flex" justifyContent="center">
        <Pagination
          count={count}
          size="large"
          page={page}
          variant="outlined"
          color="primary"
          onChange={handleChange}
        />
      </Box>

 
    </>
  );
};

export default OfferTable;
